import { environment } from "@/environment";

export function initServicePopups() {
  let openServices = () => {};
  let showServices = false;

  const host = document.location.host;
  if (
    environment !== "production" &&
    (host.startsWith("piplanning.local") || host.startsWith("setup.piplanning.local"))
  ) {
    showServices = true;
    const popups = [{ url: "https://crossbar.piplanning.local" }];
    window.addEventListener("beforeunload", closeAll);

    let current = 0;
    setInterval(() => {
      if (popups[current].window?.closed) {
        if (current + 1 < popups.length) {
          open(current + 1);
        }
      }
    }, 500);

    openServices = () => {
      closeAll();
      open(0);
    };

    function open(index) {
      current = index;
      popups[current].window = window.open(popups[current].url, "nats", "width=1000,height=2000");
    }

    function closeAll() {
      popups.forEach((popup) => popup.window?.close());
    }
  }

  return { showServices, openServices };
}
